<template>
  <div class="biz-row">
    <a :href="`/${bizDetails.slug}`" class="color-gray">
      <div class="is-clearfix biz-row__head-row">
        <img v-if="isVerified" alt="Verified" src="/static/img/business/verified.svg"/>
        <span class="is-pulled-right">
        <a :class="{'font-size-12': isMobile}" :href="`/${bizDetails.slug}`"
           class="link--v2 link--no-line">View Details</a>
        <img alt="Back to list" class="margin-left-4" src="/static/img/arrows/arrow_right_blue.svg"/>
      </span>
      </div>

      <div class="biz-row__content-row is-clearfix">
        <div :class="{'is-pulled-left': !isMobile}">
          <img :src="bizLogo(bizDetails.bizLogo)" alt="Business Logo" class="biz-row__logo"/>
          <span v-if="isMobile" class="has-text-weight-bold color-blue-dark">{{ bizDetails.bizName }}</span>
        </div>

        <div class="is-clearfix is-clipped">
          <div
            :class="{'is-pulled-left':isDesktop, 'padding-top-14': !isMobile, 'padding-top-2': isMobile, 'margin-left-8':isMobile}">
            <p v-if="!isMobile" :class="{'biz-row__name--trimmed': isDesktop, 'font-size-18': isDesktop, 'font-size-16': isTablet}"
               class="has-text-weight-bold color-blue-dark">
              {{ bizDetails.bizName }}</p>
            <div class="biz-row__score-block is-flex">
              <rating :industry-business="shrinkStars" :isAvg="true" :stars="parseFloat(bizDetails.rating)"/>
              <div class="biz-row__score-text">
                <strong>{{ bizDetails.rating.toFixed(2) }}</strong>
                <template v-if="isMobile">|</template>
                <template v-else>from</template>
                <strong>{{ bizDetails.reviewsCount.toLocaleString("en-US") }}</strong> Reviews
              </div>
            </div>
            <p v-if="showRanking" :class="{'font-size-11':isMobile}" class="is-capitalized color-blue-dark"><strong :class="{'font-size-16':!isMobile}">#
              {{ bizDetails.rank }}</strong> in
              {{ bizDetails.indusName }}</p>
          </div>
          <div :class="{'is-pulled-right':isDesktop}">
            <div class="biz-row__analytics-box margin-right-11">
              <strong>{{ bizDetails.trustIndex.toFixed(1) }}</strong>
              <p>
                <strong class="color-blue-dark">Trust</strong>Index Rating
              </p>
            </div>
            <div class="biz-row__analytics-box margin-right-11 position-relative">
              <tooltip :iconRight="9" :iconTop="10" :tooltipRight="16" :tooltipTop="16" cannedTooltip="nps" />
              <strong>{{ nps }} NPS</strong>
              <p>
                Recommend: <strong class="color-blue-dark">{{ npsRecommendation(nps) }}</strong>
              </p>
            </div>
            <div class="biz-row__analytics-box">
              <strong>{{ minutesToHours(bizDetails.avgReplyTime) }}</strong> HRS
              <p>
                <strong class="color-blue-dark">Avg</strong> Time To Reply
              </p>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import {misc} from '@/mixins'
import {Rating, Tooltip} from '@/components'

export default {
  name: 'BizRowCard',
  components: {
    Rating,
    Tooltip
  },
  mixins: [misc],
  props: {
    showRanking: {
      type: Boolean,
      default: false
    },
    bizDetails: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      shrinkStars: true,
      nps: this.npsScore(this.bizDetails.nps)
    }
  },
  computed: {
    isVerified() {
      return this.bizDetails.subscName !== 'Free'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

strong:not(.color-blue-dark) {
  color: map-get($colors, 'gray');
}

.biz-row {
  background-color: #f6f6f6;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
  padding: 13px 11px 10px 12px;
  margin-bottom: 20px;
  font-size: 14px;

  &__head-row {
    height: 34px;
  }

  &__content-row {
    background-color: #fff;
    padding: 8px 19px 15px 12px;
    border-radius: 10px;
    /*border: 1px solid;*/

    @include not-mobile {
      padding: 13px 19px 11px 13px;
    }
  }

  &__logo {
    max-width: 26px;
    border-radius: 50%;
    margin-right: 4px;
    margin-left: 8px;
    /*border: 1px solid;*/
    vertical-align: bottom;

    @include not-mobile {
      max-width: 100px;
      vertical-align: unset;
      margin-right: 25px;
      margin-left: 0;
    }
  }

  &__name--trimmed {
    max-width: 290px;
  }

  &__score-block {
    @include not-mobile {
      margin: 2px 0;
    }

    > > > .star-new {
      width: 88px;
    }
  }

  &__score-text {
    padding: 6px 0 0 11px;
    font-size: 11px;

    @include not-mobile {
      font-size: 14px;
      padding: 2px 0 0 11px;
    }
  }

  &__analytics-box {
    border-radius: 10px;
    border: 1px solid rgba(88, 89, 91, 0.32);
    padding: 13px 0 11px 10px;
    font-size: 12px;
    width: 160px;
    display: inline-block;
    margin-top: 15px;
    color: map-get($colors, 'blue-dark');

    @include mobile {
      width: 100%;
      font-size: 11px;
      padding: 5px 0 3px 10px;
      border-radius: 4px;

      > p {
        display: inline-block;
      }
    }

    > strong {
      font-size: 18px;

      @include mobile {
        font-size: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/industries/BizRowCard.vue